module.exports = __webpack_public_path__ + "static/group-d781dc4e8b9f128cfbb8836d06cef7fa.png";